var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._v(_vm._s(this.prefix + Number.parseFloat(this.value).toFixed(this.precision)))])
}
var staticRenderFns = []

export { render, staticRenderFns }